import React from 'react'
import Navbar from '../../Components/Navbar/Navbar'
import AlreadyIn from '../../Components/Already/AlreadyIn'
import NewFooter from '../../Components/NewFooter/NewFooter'
import { Footer } from '../../Components/Footer/Footer'

const AlreadyInPg = () => {
  return (
    <>
        <Navbar />
        <AlreadyIn />
        <Footer />
    </>
  )
}

export default AlreadyInPg